<template>
    <div class="job-list" v-for="(item, i) in lists" :key="i">
        <p class="job-user-meta">
            <a href="/" class="author">{{item.author}}</a>
            <span class="job-location" v-if="item.location"> - {{item.location}}</span>
            <span class="job-published" v-if="item.published"> - {{item.published}}</span>
        </p>
        <h1 v-if="item.title">
            <router-link to="/">{{item.title}}</router-link>
        </h1>
        <p class="job-meta">
            <span class="pr-1 text-success" v-if="item.salary">{{item.salary}}</span>
            <span class="pr-1 text-danger" v-if="item.visaSponsor">- Visa sponsor</span>
            <span class="pr-1 text-warning" v-else>- Remote</span>
            <span class="text-info" v-if="item.paidRelocation">- {{item.paidRelocation}}</span>
        </p>
        <ul class="question-tags d-flex flex-wrap align-center" v-if="item.tags">
            <li v-for="(tag, i) in item.tags" :key="i">
                <router-link :to="tag.url">{{tag.title}}</router-link>
            </li>
        </ul>
    </div>
</template>


<script>
    export default {
        name: 'JobLists',
        props: ['lists'],
        data() {
            return {
                
            }
        }
    }
</script>